import styled from "styled-components";
export const ImageContainer = styled.div `
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;

  transition: transform 0.5s ease-in-out;
  transform: ${({ hovered }) => hovered && "scale(1.03)"};

  align-items: center;
  > button {
    position: absolute;
  }
`;
export const ImageWrapper = styled.div `
  position: relative;
  width: 100%;
  height: 100%;

  ${({ image, fallbackImg }) => `background-image: url(${image}) ${fallbackImg ? `, url(${fallbackImg})` : ""};`}
  background-position: center center;
  background-size: ${({ imageStyles }) => imageStyles.size};
  background-repeat: ${({ imageStyles }) => imageStyles.repeat ? "repeat" : "no-repeat"};
  ${({ backgroundColor }) => `${backgroundColor ? `background-color: ${backgroundColor}` : ""};`}
  transition: transform 0.5s ease-in-out;
`;
export const PlayVideoButtonContainer = styled.div `
  position: relative;
`;
